<template>
  <main
    :class="[
      'public-page-wrapper',
      page + '-wrapper',
      displayLayout,
      isNewClass,
    ]"
  >
    <PublicHeader
      :title="title"
      v-show="canShowHeader"
      @click="back"
      :directBack="directBack"
      :hasBottomBorder="hasHeaderBorder"
      :headerImage="headerImage"
      :page="page"
      :iconName="iconName"
      :iconColor="iconColor"
      :titleColor="titleColor"
      :iconPic="iconPic"
      :backColor="backColor"
    >
      <slot name="header"></slot>
      <UserCenter
        :page="page"
        v-on:login="login"
        ref="loginBtn"
        :display="showLoginBtn"
        v-if="showLoginBtn !== 'none'"
        :needToTrackLogin="needToTrackLogin"
      />
    </PublicHeader>
    <section
      :class="[
        'public-page-body',
        page,
        canShowHeader ? 'has-header' : 'no-header',
      ]"
      :style="{ backgroundColor: bgColor }"
    >
      <slot name="page"></slot>
      <!-- 兼容PC、不显示头部导航 -->
      <slot name="desktopPage"></slot>
    </section>
    <div class="page-bottom" style="width: 100px; height: 1px"></div>
    <UserCenter
      :page="page"
      v-on:login="login"
      ref="loginBtn"
      display="none"
      v-if="showLoginBtn === 'none'"
      :needToTrackLogin="needToTrackLogin"
    />
  </main>
</template>
<script>
  import PublicHeader from '@/components/PublicHeader'
  import { mounted_track, show } from '@/pages/firebase'
  import UserCenter from '../UserCenter'
  import { mapState, mapGetters } from 'vuex'

  export default {
    props: {
      doTrack: {
        type: Boolean,
        default: true,
      },
      onlyTrackShow: {
        type: Boolean,
        default: false,
      },
      showHeader: {
        type: Boolean,
        default: true,
      },
      title: {
        default: 'Toplupe',
        type: String,
      },
      directBack: {
        default: true,
        type: Boolean,
      },
      page: {
        require: true,
        type: String,
      },
      bgColor: {
        type: String,
        default: '#fff',
      },
      hasHeaderBorder: {
        default: true,
        type: Boolean,
      },
      showLoginBtn: {
        default: 'none',
        type: String,
      },
      headerImage: {
        default: '',
        type: String,
      },
      iconPic: {
        default: '',
        type: String,
      },
      needToTrackLogin: {
        type: Boolean,
        default: true,
      },
      iconName: {
        default: 'icon-arrow',
        type: String,
      },
      iconColor: {
        default: '#000',
        type: String,
      },
      titleColor: {
        type: String,
      },
      backColor: {
        type: String,
        default: '',
      },
    },
    components: {
      PublicHeader,
      UserCenter,
    },
    created() {
      if (this.onlyTrackShow) {
        show({ page: this.page })
      }
    },
    mounted() {
      if (this.doTrack && !this.onlyTrackShow) {
        mounted_track({ page: this.page })
      }
    },
    computed: {
      ...mapState(['userInfo', 'isApp']),
      ...mapGetters(['isNewClass', 'displayLayout']),
      canShowHeader() {
        return this.showHeader && !this.isApp
      },
    },
    methods: {
      login(data) {
        this.$emit('login', data)
      },
      gotoLogin(type = '') {
        this.$refs.loginBtn && this.$refs.loginBtn.loginBtn(type)
      },
      showLoginPopup(options) {
        this.$refs.loginBtn && this.$refs.loginBtn.loginBtn(options)
      },
      back() {
        this.$emit('back')
      },
    },
  }
</script>

<style lang="scss" scoped>
  .public-page-wrapper {
    .public-page-body {
      width: 100%;
      min-height: 100vh;
      &.has-header {
        min-height: calc(100vh - 170px);
        &.pay-result {
          min-height: calc(100vh - 150px);
        }
      }
    }
  }
  .public-page-wrapper.desktop-layout {
    width: 1080px;
    margin: 0 auto;
    .public-page-body {
      position: relative;
      min-height: calc(100vh - 82.88px);
    }
  }
  .public-page-wrapper.membersPrivilege-wrapper {
    width: 100%;
  }
</style>
